var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useState } from 'react';
import { useMutation } from '@apollo/client';
import { usePlai } from 'app/domains/review/components/PlaiProvider';
import { RECOVER_FEEDBACK_MUTATION } from './mutation';
export function useRecoverFeedback() {
    const plai = usePlai();
    const [isError, setError] = useState(false);
    const [mut, { error, loading }] = useMutation(RECOVER_FEEDBACK_MUTATION);
    useEffect(() => {
        if (error) {
            setError(true);
        }
    }, [error]);
    return {
        recoverFeedback: (input) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            const result = yield mut({ variables: { feedbackId: input.feedbackId } });
            if ((_a = result.data) === null || _a === void 0 ? void 0 : _a.recoverReviewFeedback.ok) {
                plai.refetchReview();
                return true;
            }
            setError(true);
            return false;
        }),
        error: isError,
        loading,
    };
}
